import { UnitStatusEnum } from '@/enums/UnitStatus';

export const DEFAULT_PURCHASE_MIN_PRICE = 200000;
export const DEFAULT_PURCHASE_MAX_PRICE = 800000;

export const DEFAULT_PURCHASE_UNIT_STATUSES = [UnitStatusEnum.Upcoming, UnitStatusEnum.Available, UnitStatusEnum.Reserved, UnitStatusEnum.Sold];

export const DEFAULT_PURCHASE_VALID_UNIT_STATUSES = [UnitStatusEnum.Upcoming, UnitStatusEnum.Available, UnitStatusEnum.Reserved];